// @flow
import React from 'react'

type Props = {
  pathProps?: any,
  svgProps?: any,
}

export default (props: Props) => {
  const pathProps = props.pathProps || {}
  const svgProps = props.svgProps || {}
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" {...svgProps}>
      <g fill="none" fillRule="evenodd">
        <path
          fill="#617182"
          {...pathProps}
          fillRule="evenodd"
          d="M5 6c1.892 0 3.479 1.107 3.892 3H1.108c.413-1.893 2-3 3.892-3M3 3c0-1.103.897-2 2-2s2 .897 2 2-.897 2-2 2-2-.897-2-2m3.879 2.337a3 3 0 1 0-3.758 0C1.291 6.024 0 7.723 0 10h10c0-2.277-1.291-3.976-3.121-4.663"
        />
      </g>
    </svg>
  )
}
